/**
 * Supported translation locales available in the application.
 * These correspond to translation files in services/answer-module/scripts/Translations.
 */
export const SUPPORTED_LOCALES: ReadonlySet<string> = new Set([
  'af-ZA',
  'bg-BG',
  'ca-ES',
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'el-CY',
  'el-GR',
  'en-CA',
  'en-GB',
  'en-US',
  'es-419',
  'es-AR',
  'es-BO',
  'es-CL',
  'es-CO',
  'es-CR',
  'es-CU',
  'es-DO',
  'es-EC',
  'es-ES',
  'es-GT',
  'es-HN',
  'es-MX',
  'es-NI',
  'es-PA',
  'es-PE',
  'es-PR',
  'es-PY',
  'es-SV',
  'es-US',
  'es-UY',
  'es-VE',
  'et-EE',
  'fi-FI',
  'fo-FO',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-FR',
  'ga-IE',
  'han-CN',
  'he-IL',
  'hr-HR',
  'hu-HU',
  'id-ID',
  'is-IS',
  'it-CH',
  'it-IT',
  'ja-JP',
  'kl-GL',
  'km-KH',
  'ko-KR',
  'lt-LT',
  'lv-LV',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'nn-NO',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'rm-puter',
  'rm-rumgr',
  'rm-surmiran',
  'rm-sursilv',
  'rm-sutsilv',
  'rm-vallader',
  'ro-RO',
  'ru-RU',
  'se-NO',
  'sk-SK',
  'sl-SI',
  'sma-NO',
  'smj-NO',
  'smn-FI',
  'smn-NO',
  'sms-FI',
  'sq-AL',
  'sr-Latn-BA',
  'sv-FI',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'vi-VN',
  'zh-CN',
  'zh-TW',
]);

/**
 * Default fallback locale when no match is found.
 */
export const DEFAULT_LOCALE = 'en-US';

/**
 * Mapping from 2-letter ISO 639-1 language codes to the preferred full locale.
 * Used when only a short code is provided (e.g., "sl" → "sl-SI").
 */
export const SHORT_CODE_TO_LOCALE: Readonly<Record<string, string>> = {
  af: 'af-ZA',
  bg: 'bg-BG',
  ca: 'ca-ES',
  cs: 'cs-CZ',
  da: 'da-DK',
  de: 'de-DE',
  el: 'el-GR',
  en: 'en-US',
  es: 'es-ES',
  et: 'et-EE',
  fi: 'fi-FI',
  fo: 'fo-FO',
  fr: 'fr-FR',
  ga: 'ga-IE',
  han: 'han-CN',
  he: 'he-IL',
  hr: 'hr-HR',
  hu: 'hu-HU',
  id: 'id-ID',
  is: 'is-IS',
  it: 'it-IT',
  ja: 'ja-JP',
  kl: 'kl-GL',
  km: 'km-KH',
  ko: 'ko-KR',
  lt: 'lt-LT',
  lv: 'lv-LV',
  nb: 'nb-NO',
  nl: 'nl-NL',
  nn: 'nn-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  rm: 'rm-puter',
  ro: 'ro-RO',
  ru: 'ru-RU',
  se: 'se-NO',
  sk: 'sk-SK',
  sl: 'sl-SI',
  sma: 'sma-NO',
  smj: 'smj-NO',
  smn: 'smn-FI',
  sms: 'sms-FI',
  sq: 'sq-AL',
  sr: 'sr-Latn-BA',
  sv: 'sv-SE',
  th: 'th-TH',
  tr: 'tr-TR',
  uk: 'uk-UA',
  vi: 'vi-VN',
  zh: 'zh-CN',
};
